"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname, useSelectedLayoutSegment } from "next/navigation";
import { Button } from "@/components/ui/button";
const menuItems = [{
  text: "Notes",
  href: "/notes"
}, {
  text: "Projects",
  href: "/projects"
}] as const;
const Menu = () => {
  const $ = _c(5);
  const pathname = usePathname();
  const segment = useSelectedLayoutSegment() || "";
  let t0;
  if ($[0] !== pathname || $[1] !== segment) {
    t0 = menuItems.map(item => {
      const isCurrent = item.href?.split("/")[1] === segment;
      const transitionTypes = item.href === "/notes" && pathname.startsWith("/notes/") ? ["nav-back"] : pathname === item.href ? undefined : ["nav-lateral"];
      return <Button key={item.href} variant="ghost" size="sm" nativeButton={false} aria-label={item.text} data-current={isCurrent || undefined} className="px-2.5 py-3.5 text-sm leading-none data-current:bg-accent/60 data-current:text-accent-foreground" render={<Link href={item.href} transitionTypes={transitionTypes} />}>{item.text}</Button>;
    });
    $[0] = pathname;
    $[1] = segment;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <nav data-slot="navigation-menu" className="flex items-center gap-2">{t0}</nav>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export { Menu };